import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import { Redirect } from 'react-router-dom';
import funciones from '../../middleware/funciones';
import config from '../../config';

class Empresas extends Component {
    constructor(props) {
        super(props);
        //const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            datos: [],
            tipo: currentUserType
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo
            }
        };
        fetch(config.servBackEnd + '/companies/', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({ datos });
                } else {
                    //console.log(data.message);
                }
            });
    }

    render() {
        const dato = (this.state.datos) ? this.state.datos : [];

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };
        const validacionUser = (this.state.tipo === '0');
        return (

            <div className="contenedor">

                {!validacionUser && <Redirect to={{ pathname: "/" }} />}
                {validacionUser &&
                    <div>
                        <Jumbotron style={style}>
                            <h1>Modulo Empresas</h1>
                        </Jumbotron>
                        <Button className="plus" size="sm" href="/empresa/crear/" variant="outline-primary">Crear Empresa</Button>
                        <Table hover bordered responsive size="sm" className="table">
                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Nombre Empresa</th>
                                    <th>Fecha Vencimiento Token</th>
                                    <th>Ultima modificacion</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>

                                {dato.map(function (currentData, index) {
                                    return <tr key={index + "d0"}>
                                        <td key={index + "d2"}>{currentData.ID_EMPRESA}</td>
                                        <td key={index + "d4"}>{currentData.RAZON_SOCIAL}</td>
                                        <td key={index + "d5"}>{currentData.TOKEN_FECHA_VENCIMIENTO}</td>
                                        <td key={index + "d14"}>{funciones.formatDate(currentData.UPDATE_AT)}</td>
                                        <td key={index + "d15"}><Button size="sm" href={"/empresa/crear/?" + currentData.ID_EMPRESA} variant="outline-primary">Editar</Button></td>
                                    </tr>;
                                })}
                            </tbody>
                        </Table>
                    </div>
                }
            </div>




        );
    }
}
export default (Empresas);


// WEBPACK FOOTER //
// ./src/components/configuracion/empresas.jsx